import { Card } from "@/components/ui/card";
import { companyInfo } from "@shared/content";
import { ProductSection } from "@/components/product/product-section";

export default function Legal() {
  return (
    <div className="min-h-screen">
      <section className="py-16 pt-24">
        <div className="container mx-auto px-4">
          <Card className="max-w-4xl mx-auto p-8">
            <h1 className="text-3xl font-bold mb-8">Is This Legal?</h1>
            <div className="prose prose-lg max-w-none">
              <p>
                Yes! Our products at {companyInfo.name} are fully compliant with federal law. The 2018 Farm Bill, formally known as the Agriculture Improvement Act of 2018, legalized hemp-derived products at the federal level. This legislation specifically removed hemp and its derivatives, including cannabinoids like CBD, from the Controlled Substances Act, provided they contain no more than 0.3% Delta-9 THC by dry weight.
              </p>
              <p className="mt-6">
                This means that as long as hemp-derived products meet the THC threshold, they are considered legal for sale and use under federal law. {companyInfo.name} ensures that all of our products comply with these regulations, undergoing rigorous third-party testing to verify quality, potency, and compliance.
              </p>
              <p className="mt-6">
                At {companyInfo.name}, transparency and trust are our priorities. We remain committed to providing high-quality, compliant products so that you can shop with confidence.
              </p>
            </div>
          </Card>
        </div>
      </section>

      <ProductSection />
    </div>
  );
}
